import { prefixObjectValues } from '../utils';

const addLayout = {
  grid: 'grid',
  card: 'card',
  addBtn: 'add-btn',
  addNewBtn: 'add-new-btn',
  cancelBtn: 'cancel-btn',
};

export default prefixObjectValues(addLayout, 'add-certs-layout');
